<template>
    <section class="odocs-spaced">
        <p>
            <o-icon pack="fas" icon="user" size="small" />
            <o-icon pack="fas" icon="home" size="small" />
            <o-icon pack="fas" icon="tachometer-alt" size="small" />
        </p>

        <p>
            <o-icon pack="fas" icon="user" />
            <o-icon pack="fas" icon="home" />
            <o-icon pack="fas" icon="tachometer-alt" />
        </p>

        <p>
            <o-icon pack="fas" icon="user" size="medium" />
            <o-icon pack="fas" icon="home" size="medium" />
            <o-icon pack="fas" icon="tachometer-alt" size="medium" />
        </p>

        <p>
            <o-icon pack="fas" icon="user" size="large" variant="success" />
            <o-icon pack="fas" icon="home" size="large" variant="info" />
            <o-icon
                pack="fas"
                icon="tachometer-alt"
                size="large"
                variant="primary" />
        </p>

        <p>
            <o-button variant="success">
                <o-icon pack="fas" icon="check" />
                <span>Finish</span>
            </o-button>

            <o-button variant="warning">
                <o-icon pack="fas" icon="check" />
                <span>Finish</span>
            </o-button>

            <o-button variant="warning">
                <o-icon pack="fas" icon="sync-alt" spin />
                <span>Refresh</span>
            </o-button>
        </p>
    </section>
</template>
